import React, { useContext, useState } from "react";
import "./BasketCard.css";
import { BasketContext } from "../context/Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStarHalf } from "@fortawesome/free-solid-svg-icons";

function BasketCard({ title, prix, src, id, desc, rating }) {
  const [basket, setBasket] = useContext(BasketContext);

  const rmFromBasket = () => {
    let index = basket.findIndex((index) => index.id === id);
    let newBasket = [...basket];
    newBasket.splice(index, 1);
    setBasket(newBasket);
  };

  var rate = parseInt(rating);

  return (
    <div className="basketCard">
      <img src={src} alt="book cover " />
      <div className="info">
        <h3>{title}</h3>
        <span className="rating">
          {rate ? (
            Array(rate)
              .fill()
              .map((_, i) => {
                return <FontAwesomeIcon icon={faStar} key={i} />;
              })
          ) : (
            <p>rating not availble</p>
          )}
          {rating > rate && rating ? <FontAwesomeIcon icon={faStarHalf} /> : ""}
        </span>
        <p className="prix">{prix === "FREE" ? prix : "$" + prix}</p>
        <p className="desc">{desc ? desc : "desccription not available"}</p>
        <div className="rm" onClick={rmFromBasket}>
          Remove from basket
        </div>
      </div>
    </div>
  );
}

export default BasketCard;
